import {request} from '../utils/request';
import {config} from '../utils/constants';
import {getCurrentSiteId} from "../utils/util";
const Liferay = window.Liferay;

export async function getLearningPaths(pageSize) {
	const data = await request({
		params: {
			fields: 'id,description,level,persona,title,position',
			pageSize,
			sort: 'position:asc',
		},
		url: `${config.learningPathsEndpoint}/scopes/${getCurrentSiteId()}`,
	});

	return data.items;
}

export const getLearningPathTitle = async (id) => {
  const response = await Liferay.Util.fetch(
    `/o/c/learningpaths/${id}?fields=title,`
  );
  const data = await response.json();
  return data;
};